import { fn, get } from '@ember/helper';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { PrismCheckbox } from '@mylighthouse/prism-ember';
import { includes } from '@nullvoxpopuli/ember-composable-helpers';
import { t } from 'ember-intl';
import {
  DATA_TYPE_TRANSLATIONS,
  type DataType,
} from 'lumen/utils/constants/budget-forecast-constants';

export interface HotelBudgetForecastExportModalSelectDataTypesSignature {
  Args: {
    dataTypes: DataType[];
    onDataTypesChange: (dataTypes: DataType[]) => void;
    selectedDataTypes: DataType[];
    view: 'budget' | 'forecast';
  };
}

export default class HotelBudgetForecastExportModalSelectDataTypes extends Component<HotelBudgetForecastExportModalSelectDataTypesSignature> {
  get availableDataTypes(): DataType[] {
    const { view, dataTypes } = this.args;
    return dataTypes.filter((dataType) => dataType !== view);
  }

  @action
  onDataTypeChange(dataType: DataType): void {
    const { selectedDataTypes, onDataTypesChange } = this.args;
    if (selectedDataTypes.includes(dataType)) {
      const dataTypes = selectedDataTypes.filter((item) => item !== dataType);
      onDataTypesChange(dataTypes);
    } else {
      const dataTypes = [...selectedDataTypes, dataType];
      onDataTypesChange(dataTypes);
    }
  }

  <template>
    <p
      class="text-300--regular"
      data-test-id="export-modal-select-data-types-description"
    >
      {{t "budget_forecast.export.select_data_points"}}:
    </p>
    <div
      class="rounded-200 border-neutral-default bg-neutral-subdued overflow-y-auto border border-solid p-400"
    >
      <div class="flex flex-col gap-400">
        {{#each this.availableDataTypes as |dataType|}}
          <PrismCheckbox
            @checked={{includes dataType @selectedDataTypes}}
            @isSmall={{true}}
            @onChange={{fn this.onDataTypeChange dataType}}
          >
            {{t (get DATA_TYPE_TRANSLATIONS dataType)}}
          </PrismCheckbox>
        {{/each}}
      </div>
    </div>
  </template>
}
